import type { NormNote } from '../helpers';
import { Muted, Table } from '../styles';

/**
 * Позиции КС-2, по которым нормативного расхода нет или он посчитан с
 * оговоркой: «нормы нет в базе», «в составе нормы нет материалов», «единицы
 * несовместимы», «единица не указана — объём взят как есть».
 */
export function NormNotesTable({ items }: { items: NormNote[] }) {
  if (items.length === 0) return null;
  return (
    <Table>
      <thead>
        <tr>
          <th>Позиция КС-2</th>
          <th>Причина</th>
        </tr>
      </thead>
      <tbody>
        {items.map((n, idx) => (
          <tr key={`${n.code}-${n.reason}-${idx}`}>
            <td>
              {n.code || '—'}
              {n.name && <Muted>{n.name}</Muted>}
            </td>
            <td>{n.message}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
